import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const PARTICIPANT_PATCH_REQUEST = 'PATCH_PARTICIPANT_REQUEST';
export const PARTICIPANT_PATCH_FAILURE = 'PATCH_PARTICIPANT_FAILURE';
export const PARTICIPANT_PATCH_SUCCESS = 'PATCH_PARTICIPANT_SUCCESS';

export const patchParticipant = (data, id) => {
    return function(dispatch) {
        dispatch(patchRequest());
        return axios(apiRequestOptions(apiPath.PARTICIPANT.PATCH, data, id))
            .then(transformHttpResponse)
            .then(response => dispatch(patchSuccess(response.data)))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(postFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const patchRequest = () => {
    return {
        type: PARTICIPANT_PATCH_REQUEST,
    }
};

const postFailure = (error) => {
    return {
        type: PARTICIPANT_PATCH_FAILURE,
        error,
    }
};

const patchSuccess = (participant) => {
    return {
        type: PARTICIPANT_PATCH_SUCCESS,
        participant,
    }
};